import { Component, OnInit } from "@angular/core";
import { UserManagementService } from "../../core/services/user-management.service";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { SharedService } from "../../core/services/shared.service";
import { UserRole } from "../../shared/enums/userRoles.enum";
import { InvoicePreviewListingPaginatedComponent } from "./invoice-preview-listing-paginated/invoice-preview-listing-paginated.component";

@Component({
  selector: "jni-invoice-preview",
  templateUrl: "./invoice-preview.component.html",
  styleUrls: ["./invoice-preview.component.scss"],
  imports: [InvoicePreviewListingPaginatedComponent],
})
export class InvoicePreviewComponent implements OnInit {
  userRole = 0;

  invoicePreviewAdminStatus = false;

  constructor(
    private _loginService: UserManagementService,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.getUserRole();
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  getUserRole() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.invoicePreviewAdminStatus = true;
        }
      });
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }
}
